import * as Yup from 'yup'

export const validationSchema = t => {
    return {
        email: Yup.string()
            .typeError(t('validation.valid.char'))
            .email(t('validation.invalid.email'))
            .required(t('validation.enter.email')),
    }
}
